<template>
  <section>
    <h3>Exportar planilhas - Financeiro</h3>
    <div class="botoes">
      <!-- <exportar-evidencia> </exportar-evidencia> -->
      <!-- <exportar-glosa> </exportar-glosa> -->
      <!-- <export-sla class="botoes-oper"> </export-sla> -->
      <export-extracontratual class="botoes-oper"> </export-extracontratual>
      <export-fechamento-fixo-variavel class="botoes-oper"> </export-fechamento-fixo-variavel>
    </div>

    <h3>Exportar planilhas - Operacional</h3>
    <div class="botoes">
      <export-orcamentos-aprovados class="botoes-oper"></export-orcamentos-aprovados>
      <export-chamados class="botoes-oper"></export-chamados>
      <export-log-setembro-2019 class="botoes-oper"></export-log-setembro-2019>
      <export-preventivas class="botoes-oper"></export-preventivas>
      <export-log-preventivas class="botoes-oper"></export-log-preventivas>
    </div>

    <h3>Exportar planilhas - Novo SSP</h3>
    <div class="botoes">
      <export-adm-chamados class="botoes-oper"></export-adm-chamados>
      <export-adm-historico-chamados class="botoes-oper"></export-adm-historico-chamados>
      <export-adm-deaverage class="botoes-oper"></export-adm-deaverage>
      <export-adm-preventivas class="botoes-oper"></export-adm-preventivas>
      <export-adm-franquias class="botoes-oper"></export-adm-franquias>
      <export-adm-franquias-chamados class="botoes-oper"></export-adm-franquias-chamados>
      <export-adm-historico-negociacoes class="botoes-oper"></export-adm-historico-negociacoes>
      <export-adm-extintores class="botoes-oper"></export-adm-extintores>
      <button v-if="!controlerBtnSubmit" type="button" class="btn btn-success botoes-oper" @click="exportarBaseSimulacao">Relatório Preventivas 2024/2025 (Excel)</button>
      <button v-if="controlerBtnSubmit" type="button" class="btn btn-secondary botoes-oper" disabled><i class='fa fa-refresh fa-spin'></i> Exportando...</button>
      <export-adm-franquia-dinamica class="botoes-oper"></export-adm-franquia-dinamica>
    </div>

    <br>

    <h3>Exportar relatórios semanais - Novo SSP</h3>
    <div class="botoes">
      <export-adm-franquias-semanais class="botoes-oper"></export-adm-franquias-semanais>
      <export-adm-preventivas-semanais class="botoes-oper"></export-adm-preventivas-semanais>
    </div>
    <br>
    
    <h3>Exportar evidência de SLA</h3>
    <div>
      Temporariamente desativado
      <!-- <export-sla-adm></export-sla-adm> -->
    </div>
  </section>
</template>
<script>
// Export Planilhas
// import exportarGlosa from './glosa/ExportarGlosa.vue'
// import exportarEvidencia from './evidencia/ExportarEvidencia.vue'
import axios from 'axios'
import exportFechamentoFixoVariavel from './fechamento-fixo-variavel/ExportFechamentoFixoVariavel.vue'
// import exportSla from './planilhaGeral/ExportSla.vue'
import exportExtraContratual from './extracontratual/ExportarFechamentoExtra.vue'
import exportOrcamentosAprovados from './orcamento/ExportOrcamentosAprovados.vue'
// Export Planilhas Operacional
import exportChamados from './planilhas-operacional/ExportChamados'
import exportLogPreventivas from './planilhas-operacional/ExportLogPreventivas'
import exportLogSetembro2019 from './planilhas-operacional/ExportLogSetembro2019'
import exportPreventivas from './planilhas-operacional/ExportPreventivas'

import exportAdmFranquiasSemanais from './planilhas-adm/ExportChamados'

// Export Planilhas Adm
import exportAdmChamados from './planilhas-adm/ExportChamados'
import exportAdmHistoricoChamados from './planilhas-adm/ExportHistoricoChamados'
import exportAdmDeaverage from './planilhas-adm/ExportChamadosDeaverage'
import exportAdmPreventivas from './planilhas-adm/ExportPreventivas'
import exportAdmFranquias from './planilhas-adm/ExportFranquias'
import exportAdmFranquiasChamados from './planilhas-adm/ExportFranquiasChamados'
import exportHistoricoNegociacoes from './planilhas-adm/ExportHistoricoNegociacoes'
import exportAdmExtintores from './planilhas-adm/ExportExtintores'
import exportFranquiaDinamica from './planilhas-adm/ExportFranquiaDinamica'
import exportRelatorioSemanalFranquias from './planilhas-adm/ExportRelatorioSemanalFranquias'
import exportRelatorioSemanalPreventivas from './planilhas-adm/ExportRelatorioSemanalPreventivas'

// Export Evidência de SLA
// import exportarSlaAdm from './sla-predial-adm/ExportarSlaAdm.vue'
export default {
  data() {
    return {
      env: process.env,
      controlerBtnSubmit: false
    }
  },
  computed: {
    isFabricio() {
      try {
        const email = (this.$store.state.login.loginUsuario.usuario.email || '').toLowerCase()
        return email === 'fabricio.elias@portalssp.com'
      } catch (e) {
        return false
      }
    }
  },
  components: {
    // Export Planilhas
    // 'exportar-glosa': exportarGlosa,
    // 'exportar-evidencia': exportarEvidencia,
    'export-fechamento-fixo-variavel': exportFechamentoFixoVariavel,
    // 'export-sla': exportSla,
    'export-extracontratual': exportExtraContratual,
    'export-orcamentos-aprovados': exportOrcamentosAprovados,
    // Export Planilhas Operacional
    'export-chamados': exportChamados,
    'export-log-preventivas': exportLogPreventivas,
    'export-log-setembro-2019': exportLogSetembro2019,
    'export-preventivas': exportPreventivas,
    
    'export-adm-franquias-semanais': exportRelatorioSemanalFranquias,
    'export-adm-preventivas-semanais': exportRelatorioSemanalPreventivas,
    
    // Export Planilhas Adm
    'export-adm-chamados': exportAdmChamados,
    'export-adm-historico-chamados': exportAdmHistoricoChamados,
    'export-adm-deaverage': exportAdmDeaverage,
    'export-adm-preventivas': exportAdmPreventivas,
    'export-adm-franquias': exportAdmFranquias,
    'export-adm-franquias-chamados': exportAdmFranquiasChamados,
    'export-adm-historico-negociacoes': exportHistoricoNegociacoes,
    'export-adm-extintores': exportAdmExtintores,
    'export-adm-franquia-dinamica': exportFranquiaDinamica,
    // Export Evidência de SLA
    // 'export-sla-adm': exportarSlaAdm
  },
  methods: {
    exportarBaseSimulacao() {
      // if (!this.isFabricio) return
      this.controlerBtnSubmit = true
      axios({
        url: `${this.env.FINANCEIRO.SLA}/export-base-simulacao`,
        method: 'post',
        data: {},
        headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
      })
        .then(response => {
          const arquivo = response.data && response.data.arquivo_download
          if (arquivo) {
            const urlDownload = `${this.env.FINANCEIRO.SLA}/download-arquivo-xlsx/${arquivo}`
            axios.get(urlDownload, {
              responseType: 'blob',
              headers: { 'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}` }
            }).then((resp) => {
              const blob = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
              const link = document.createElement('a')
              const url = window.URL.createObjectURL(blob)
              link.href = url
              const sugestao = arquivo || `BaseESimulacao-${new Date().toISOString().slice(0, 10)}.xlsx`
              link.setAttribute('download', sugestao)
              document.body.appendChild(link)
              link.click()
              link.parentNode.removeChild(link)
              window.URL.revokeObjectURL(url)
            }).catch(() => {
              window.open(urlDownload, '_blank')
            })
          }
        })
        .finally(() => {
          this.controlerBtnSubmit = false
        })
    }
  }
}
</script>
<style scoped>
.botoes {
  display: flex;
  flex-wrap: wrap;
}

.botoes-oper {
  margin-left: 2px;
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// DownloadCsv.vue?2dce2601